const DEFAULT_FALSE = false
const DEFAULT_TRUE = true

const FIELD_PROPERTY_DISABLED = 'disabled'
const FIELD_PROPERTY_REQUIRED = 'required'
const FIELD_PROPERTY_VISIBLE = 'visible'
const FIELD_PROPERTY_FEATURED = 'featured'
const FIELD_PROPERTY_READONLY = 'readonly'
export {DEFAULT_FALSE, DEFAULT_TRUE, FIELD_PROPERTY_DISABLED,FIELD_PROPERTY_FEATURED, FIELD_PROPERTY_REQUIRED, FIELD_PROPERTY_VISIBLE, FIELD_PROPERTY_READONLY}
